export const interactionHelper = {
  getClientKey,
  setClientKey,
};

function setClientKey(id, key, expoId = null, expoHost = false) {
  if (expoId)
    localStorage.setItem(`EXPO${expoHost ? "_HOST" : ""}_KEY_${expoId}`, key);
  else {
    localStorage.setItem(`CLIENT_KEY_${id}`, key);
  }
}

function getClientKey(id, expoId = null, expoHost = false) {
  if (expoId)
    return (
      localStorage.getItem(`EXPO${expoHost ? "_HOST" : ""}_KEY_${expoId}`) ||
      null
    );
  return localStorage.getItem(`CLIENT_KEY_${id}`) || null;
}